/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";
import { useDencrypt } from "use-dencrypt-effect";

import './Works.css';

// Import ../../assets/recentprojects/
import Portfolio from '../../assets/recentprojects/react-portfolio.png';
import Cubik from '../../assets/recentprojects/veritru.png';
import Newmotorssport from '../../assets/recentprojects/lofo.png';
import Rallier from '../../assets/recentprojects/startup.png';
import Somniterre from '../../assets/recentprojects/lacalle.png';
import FitZone from '../../assets/recentprojects/fitzone.png';
import Veilletech from '../../assets/recentprojects/veilletech.png';
import iCatNap from '../../assets/recentprojects/icatnap.png';

const decryptOptions = {
  chars: [
    "-", ".", "/", "*", "!", "?", "#", "%", "&", "@", "$", "€",
    "(", ")", "[", "]", "{", "}", "<", ">", "~",
    "0", "1", "2", "3", "4", "5", "6", "7", "8", "9",
    "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m",
    "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z",
  ],
  interval: 50,
};

const TextDecryptSpan = ({ text }) => {
  const { result, dencrypt } = useDencrypt(decryptOptions);

  useEffect(() => {
    const updateText = () => {
      dencrypt(text || "");
    };
    const action = setTimeout(updateText, 0);
    return () => clearTimeout(action);
  }, [dencrypt, text]);

  return <span>{result}</span>;
};

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: '100vw',
    marginTop: '3em',
    marginBottom: "auto",
  },
}));

export const Works = () => {
  const classes = useStyles();
  
  // Initial state with all projects
  const [projects] = useState([
    { 
      id: 1,
      title: 'Cubik Partners', 
      description: `Worked on maintaining and upgrading a corporate WordPress site. Tasks included theme and plugin updates, core functionality tweaks in PHP, and security fixes. This project pushed me to learn backend development and sharpen my WordPress skills.`,
      alter: 'Cubik Partners',
      image: `${Cubik}`,
      url: 'https://www.cubik-partners.com', // Add your project URL here
    },
    { 
      id: 2,
      title: 'Newmotorssport', 
      description: `Transformed a Figma design into a pixel-perfect website using WordPress and Elementor. I handled both the design and development, ensuring full responsiveness and client satisfaction throughout.`,
      alter: 'Newmotorssport',
      image: `${Newmotorssport}`,
      url: 'https://www.newmotorssport.com', // Add your project URL here
    },
    { 
      id: 3,
      title: 'Jacqueline Rallier', 
      description: `Ongoing support for a professional WordPress site built with the Avada theme. My work included site updates, content additions, layout changes, and maintaining smooth performance across the board.`,
      alter: 'Jacqueline Rallier',
      image: `${Rallier}`,
      url: 'https://jacquelinerallier.com', // Add your project URL here
    },
    { 
      id: 4,
      title: 'Somniterre', 
      description: `A custom-built React website for a D&D campaign. Designed the UI in Figma and built an interactive map using Konva.js. It's a niche passion project, but one that shows my ability to combine creativity with front-end development.`,
      alter: 'Somniterre',
      image: `${Somniterre}`,
      url: '#', // Add your project URL here
    },
    { 
      id: 5,
      title: 'React Portfolio', 
      description: `A fully custom-coded React site built to showcase my work. While the design wasn't mine, I developed everything from scratch for full control and future flexibility. Also learned and implemented Three.js for 3D elements.`,
      alter: 'React Portfolio',
      image: `${Portfolio}`,
      url: '#', // Add your project URL here
    },
    { 
      id: 6,
      title: 'iCatNap', 
      description: `A creative meditation app inspired by the soothing sound of cat purring. Also included a feature to locate cat adoption centers by region. Simple build using HTML and CSS, but a fun concept that hit the mark.`,
      alter: 'iCatNap',
      image: `${iCatNap}`,
      url: 'https://tsukijidsgn.github.io/purrnap', // Add your project URL here
    },
    { 
      id: 7,
      title: 'TechMonitor', 
      description: `A personal React app created to track daily tech news from multiple sources. Built out of frustration with paywalls and cluttered news feeds. Lightweight, fast, and does exactly what I need—no more endless scrolling.`,
      alter: 'Veilletech',
      image: `${Veilletech}`,
      url: '#', // Add your project URL here
    },
    { 
      id: 8,
      title: 'FitZone', 
      description: `One of several personal projects aimed at improving my design and coding skills. Built a fitness-themed landing page using HTML, CSS, and vanilla JS to test responsive layouts and user-friendly UI components. If you would like to see more projects, you can find them on my GitHub repository, or ask me to share them with you.`,
      alter: 'FitZone',
      image: `${FitZone}`,
      url: 'https://tsukijidsgn.github.io/The-FitZone', // Add your project URL here
    },
  ]);

  // State to toggle between showing 3 projects or all
  const [showAll, setShowAll] = useState(false);

  // Function to toggle showAll state
  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  return (
    <section id="works">
      <Container component="main" className={classes.main} maxWidth="md">
        {projects.slice(0, showAll ? projects.length : 3).map((project) => (
          <div className="project" key={project.id}>
            <div className="__img_wrapper">
              <img src={project.image} alt={project.alter} />
            </div>
            <div className="__content_wrapper">
              <h3 className="title">
                {project.url && project.url !== '#' ? (
                  <a 
                    href={project.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="project-link"
                  >
                    <TextDecryptSpan text={project.id + '. ' + project.title} />
                  </a>
                ) : (
                  <TextDecrypt text={project.id + '. ' + project.title} />
                )}
              </h3>
              <p className="description">
                {project.description}
              </p>
            </div>
          </div>
        ))}
        <button onClick={toggleShowAll} className="see-more-btn">
          <span className="btn-text">{showAll ? '>_See less.' : '>_See more.'}</span>
        </button>
      </Container>
    </section>
  );
};